import { render, staticRenderFns } from "./lottery-K3.vue?vue&type=template&id=7a283d17&scoped=true"
import script from "./lottery-K3.vue?vue&type=script&lang=js"
export * from "./lottery-K3.vue?vue&type=script&lang=js"
import style0 from "./lottery-K3.vue?vue&type=style&index=0&id=7a283d17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a283d17",
  null
  
)

export default component.exports